<template>
  <div :id="id" style="width: 100%;height: 600px;"></div>

</template>

<style scoped></style>

<script>
  import GhDiagram from "./ghDiagram.ts";
  export default GhDiagram;
</script>